import { Edit } from 'lucide-react';

export default function SettingsHeader({ isUpdating }) {
  return (
    <div className="bg-white border-b border-gray-200 px-4 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
          <p className="text-xs text-gray-600 mt-1">Manage your company profile and preferences</p>
        </div>
        {/* <button
          disabled={isUpdating}
          className="px-4 py-2.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-lg text-xs font-bold flex items-center gap-1.5 shadow-md hover:shadow-lg disabled:opacity-70"
        >
          <Edit className="w-4 h-4" />
          {isUpdating ? 'Saving...' : 'Save Changes'}
        </button> */}
      </div>
    </div>
  );
}